/*=========================================================================================
  File Name: moduleReportFormConfigGetters.js
  Description: Request Type Config Module Getters
==========================================================================================*/
import constant from "@/utils/constant.js";

const formatControls = (controls = []) =>
	controls.map(control => ({
		...control,
		description: {
			...control.description,
			position: control.description.position || constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM
		},
		children: typeof control.children === "string" ? JSON.parse(control.children) : control.children
	}));

export default {
	getReportFormData: state => ({
		...state.reportForm,
		isDisabled: !state.reportForm.enable,
		controls: formatControls(state.reportForm.controls || [])
	})
};
